import React, { useMemo, useState } from 'react';
import GalleryCard from './GalleryCard';
import styles from '../styles/Design_Lab.module.css';
import { pins } from '../gallery_images/pins';

const filterButtons = [
    { label: 'Landing Pages', value: 'Landing Pages' },
    { label: 'Logo Design', value: 'Logo Design' },
    { label: 'Full Websites', value: 'Full Website' },
    { label: 'Custom Web/App Builds', value: 'Custom Web/App Builds' },
    { label: 'Brand Identity & Strategy', value: 'Brand Identity & Strategy' },
    { label: 'UX/UI Design', value: 'UX/UI Design' },
];

const Gallery = () => {
    const [activeCategory, setActiveCategory] = useState('all');

    const filteredPins = useMemo(() => {
        if (activeCategory === 'all') return pins;
        return pins.filter((pin) => pin.category === activeCategory);
    }, [activeCategory]);

    return (
        <div className={styles.pageShell}>
            <div className={styles.pageContainer}>
                <div className={styles.pageLayout}>
                    <aside className={styles.indexRail} aria-hidden="true">
                        <span className={styles.indexRailLabel}>
                            Design Portfolio
                        </span>
                    </aside>

                    <main className={styles.mainContent}>
                        <header className={styles.magazineHeader}>
                            <div className={styles.magazineHeaderTop}>
                                <span className={styles.magazineKicker}>
                                    Meshae Studios
                                </span>

                                <span className={styles.magazineIssue}>
                                    Design & Development Portfolio
                                </span>
                            </div>

                            <h1 className={styles.magazineTitle}>Portfolio</h1>
                        </header>

                        <section
                            className={styles.categorySection}
                            aria-label="Project categories"
                        >
                            <span className={styles.categoryLabel}>Categories</span>

                            <div className={styles.categoryBar}>
                                <button
                                    type="button"
                                    className={`${styles.categoryButton} ${activeCategory === 'all'
                                        ? styles.categoryButtonActive
                                        : ''
                                        }`}
                                    onClick={() => setActiveCategory('all')}
                                >
                                    all
                                </button>

                                {filterButtons.map((item) => (
                                    <button
                                        key={item.value}
                                        type="button"
                                        className={`${styles.categoryButton} ${activeCategory === item.value
                                            ? styles.categoryButtonActive
                                            : ''
                                            }`}
                                        onClick={() =>
                                            setActiveCategory(item.value)
                                        }
                                    >
                                        {item.label}
                                    </button>
                                ))}
                            </div>
                        </section>

                        <section
                            className={styles.projectListSection}
                            id="design-projects"
                            aria-label="Projects"
                        >
                            <div className={styles.projectList}>
                                {filteredPins.map((pin, index) => (
                                    <GalleryCard
                                        key={pin.slug}
                                        pin={pin}
                                        index={index}
                                        total={filteredPins.length}
                                    />
                                ))}
                            </div>
                        </section>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Gallery;